export default (opts = {}) => ({
    swiper: null,
    initialized: false,
    analytics: {
        label: opts.label || null,
        currency: opts.currency || null,
        listId: opts.listId || 'featured_collection',
    },
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.featuredCollectionProducts, {
            slidesPerView: 3.5,
            spaceBetween: 8,
            pagination: false,
            loop: false,
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                },
                568: {
                    slidesPerView: 2.25,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1280: {
                    slidesPerView: 3.25,
                },
                1536: {
                    spaceBetween: 12,
                    slidesPerView: 3.5,
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
            on: {
                init: () => {
                    this.initialized = true;
                },
            },
        });
    },
    onItemClick(event) {
        const link = event.target.closest('.swiper-slide a');
        if (!link) return;
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;

        const item = {
            item_id: slide.dataset.itemId,
            item_name: slide.dataset.itemName,
        };

        const payload = {
            event: 'view_item_list',
            currency: this.analytics.currency,
            item_list_id: this.analytics.listId,
            item_list_name: this.analytics.label,
            items: [item],
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    },
    onItemKeydown(event) {
        // Support keyboard activation for analytics parity with click
        if (event.key !== 'Enter' && event.key !== ' ') return;
        // Prevent page scroll on Space
        event.preventDefault();
        this.onItemClick(event);
    },
});
